import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';

// Thư viện lightbox (+ CSS) chỉ được tải ở lần đầu người dùng bấm vào một ảnh,
// không đè lên bundle của mọi trang import components/common.
const ImageLightbox = lazy(() => import('./ImageLightbox'));

// Tải chunk có thể hỏng: deploy dùng `s3 sync --delete`, tab mở từ trước deploy
// sẽ không còn chunk cũ. Không chặn ở đây thì lỗi lan lên AppErrorBoundary và
// cả app thành màn hình lỗi — mất luôn câu trả lời đang gõ dở.
class LightboxErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    this.props.onError();
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}

LightboxErrorBoundary.propTypes = {
  onError: PropTypes.func.isRequired,
  children: PropTypes.node,
};

/**
 * Nhận `gallery` = { slides: [{ src, alt }], index } hoặc null (đang đóng).
 */
const LazyImageLightbox = ({ gallery, onClose }) => {
  if (!gallery || gallery.slides.length === 0) return null;

  // Không xem được trong lightbox thì ít nhất mở ảnh gốc ở tab mới.
  const handleLoadError = () => {
    const slide = gallery.slides[gallery.index] || gallery.slides[0];
    if (slide?.src && !slide.src.startsWith('data:')) window.open(slide.src, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <LightboxErrorBoundary onError={handleLoadError}>
      <Suspense fallback={null}>
        <ImageLightbox open slides={gallery.slides} index={gallery.index} onClose={onClose} />
      </Suspense>
    </LightboxErrorBoundary>
  );
};

LazyImageLightbox.propTypes = {
  gallery: PropTypes.shape({
    slides: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string.isRequired })).isRequired,
    index: PropTypes.number,
  }),
  onClose: PropTypes.func.isRequired,
};

export default LazyImageLightbox;
